module.exports = __webpack_public_path__ + "media/images/samples/1280x768/2-7e41cd6bacdb0d58117c0c51ea5c0016.jpg";